"use strict";

var _defineProperty = require("/root/website/node_modules/@babel/runtime/helpers/defineProperty");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.redirectToAutoRefi = exports.redirectToHomeEquity = void 0;

var _queryString = _interopRequireDefault(require("query-string"));

var _constants = require("../constants");

var _factories = require("../factories");

var _windowGlobal3 = require("./window-global");

var createParams = function createParams(params) {
  var _windowGlobal, _windowGlobal$locatio;

  var _windowGlobal3$URL = new _windowGlobal3.URL((_windowGlobal = (0, _windowGlobal3.windowGlobal)()) == null ? void 0 : (_windowGlobal$locatio = _windowGlobal.location) == null ? void 0 : _windowGlobal$locatio.href),
      search = _windowGlobal3$URL.search;

  var queryParams = _queryString.default.stringify(_objectSpread(_objectSpread({}, _queryString.default.parse(search)), params));

  return queryParams;
};

var redirectToProduct = function redirectToProduct(url, params) {
  var _windowGlobal2, _windowGlobal2$locati;

  var queryParams = createParams(params);
  var redirectURL = "".concat(url, "?").concat(queryParams);
  return (_windowGlobal2 = (0, _windowGlobal3.windowGlobal)()) == null ? void 0 : (_windowGlobal2$locati = _windowGlobal2.location) == null ? void 0 : _windowGlobal2$locati.assign(redirectURL);
};

var redirectToHomeEquity = function redirectToHomeEquity(intendedCredit) {
  redirectToProduct(_constants.HOME_EQUITY_URL, (0, _factories.createLoanProductParams)({
    intendedCredit: intendedCredit
  }));
};

exports.redirectToHomeEquity = redirectToHomeEquity;

var redirectToAutoRefi = function redirectToAutoRefi(intendedCredit) {
  redirectToProduct(_constants.AUTO_REFI_URL, (0, _factories.createLoanProductParams)({
    intendedCredit: intendedCredit
  }));
};

exports.redirectToAutoRefi = redirectToAutoRefi;